import {
  Input,
  OnInit,
  Output,
  OnDestroy,
  Component,
  ViewChild,
  ElementRef,
  EventEmitter,
} from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';

import { debounceTime, distinctUntilChanged, repeat } from 'rxjs/operators';

import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';

const DEBOUNCE_TIME = 750;
const DEFAULT_MIN_QUERY_LENGTH = 3;

@Component({
  selector: 'tablesready-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false,
})
export class SearchBarComponent implements OnInit, OnDestroy {
  @ViewChild('query', { read: ElementRef }) inputElement: ElementRef;

  @Input() placeholder = 'Search';
  @Input() inputFieldHidden = false;
  @Input() minQueryLength = DEFAULT_MIN_QUERY_LENGTH;
  @Output() search = new EventEmitter<string>();

  icon = AppIcon;
  iconColor = AppIconColor;
  showInputField = false;
  form = new UntypedFormGroup({ searchString: new UntypedFormControl('') });
  searchInput = new BehaviorSubject<string>('');
  private readonly subscription = new Subscription();

  get searchString(): AbstractControl {
    return this.form.get('searchString');
  }

  get searchStringLength(): number {
    const value = String(this.searchString?.value);

    return value.length;
  }

  onWrapperClick(): void {
    if (this.inputFieldHidden && !this.showInputField) {
      this.showInputField = true;

      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      }, 0);
    }
  }

  clearSearchField(): void {
    this.newSearch('');
    this.showInputField = false;
  }

  newSearch(searchString: string): void {
    this.searchString.setValue(searchString);

    if (searchString.length < this.minQueryLength && searchString?.trim() !== '') {
      return;
    }

    this.searchInput.next(searchString);
  }

  ngOnInit(): void {
    this.subscription.add(this.searchInput.asObservable()
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        distinctUntilChanged(),
        repeat(),
      )
      .subscribe((search) => {
        this.search.emit(search.toLowerCase());
      }));
  }

  get displayInputField(): boolean {
    if (this.inputFieldHidden) {
      return this.showInputField;
    }

    return true;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
